import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import "./style.scss";
import { Layout, PageHeader, Spin, message } from "antd";
import { useHistory } from "react-router";
import R2Footer from "../../../components/Footer";
import TableDetails from "./TableDetails";
import TableConfiguration from "./TableConfiguration";
import PosService from "../../../services/PosService";
import { v4 as uuidv4 } from "uuid";
import Spinner from "../../../components/Layout/Spinner";

const { Content } = Layout;

const TableManagement = () => {
  const adminRestaurant = useSelector((state) => state.admin);
  const [loading, setLoading] = useState(false);
  const [showSection, setShowSection] = useState(false);
  const history = useHistory();

  const [tableData, setTableData] = useState({});

  useEffect(() => {
    getSectionAndTablesData();
  }, [adminRestaurant]);

  const getSectionAndTablesData = async () => {
    setLoading(true);
    const sectionsFilter = await PosService.getSections(adminRestaurant);
    const sectionUpdatedName = sectionsFilter.filter(
      (value, index, self) =>
        index === self.findIndex((t) => t.floor === value.floor)
    );
    const sectiondata = sectionUpdatedName.map((item) => {
      return {
        ...item,
        name:
          sectionsFilter.filter((itemFilter) => itemFilter.floor == item.floor)
            ?.length + "",
      };
    });
    const tabledata = await PosService.getTables(adminRestaurant);
    // const data = await PosService.getSectionTableMapping(adminRestaurant);
    setLoading(false);
    const colorsBorder = [
      "aqua",
      "black",
      "blue",
      "fuchsia",
      "gray",
      "green",
      "lime",
      "maroon",
      "navy",
      "olive",
      "orange",
      "purple",
      "red",
      "silver",
      "teal",
      "white",
      "yellow",
    ];

    const occupancyData = tabledata?.map((item, i) => {
      const obj = {
        occupancy: item.occupancy,
        number_of_table: item.number_of_table,
        paddingRight: 2 * item.occupancy + "px",
        id: item.id,
        color: colorsBorder[i] ? colorsBorder[i] : "red",
      };
      return obj;
    });

    const tabledataRestaurent = await PosService.getRestaurentTables(
      adminRestaurant
    );
    const floorData = sectiondata?.map((item) => {
      let dataSec = [];
      const floorFilter = sectionsFilter.filter(
        (flooritem) => item.floor == flooritem.floor
      );
      for (var i = 0; i < floorFilter.length; i++) {
        const obj = {
          id: floorFilter[i].id,
          sections: [],
          // sections: tabledataRestaurent
          //   .filter((itemTable) => itemTable.table_number == i)
          //   .map((itemmap, i) => {
          //     if (itemmap.section_id === item.id) {
          //       const newItem = {
          //         id: itemmap.table_type_id,
          //         text: itemmap.table_type?.occupancy,
          //         color: colorsBorder[i],
          //         paddingRight: 2 * item.table_type?.occupancy + "px",
          //         table_number: itemmap.table_number,
          //       };
          //       return newItem;
          //     }
          //   })
          //   .filter((itemundefined) => item !== undefined),
        };
        dataSec.push(obj);
      }
      const obj = {
        floor: item.floor,
        name: item.name,
        id: item.id,
        sectionsMap: dataSec,
      };
      return obj;
    });
    console.log(floorData);
    setTableData({
      sectionData: floorData,
      tableData: occupancyData,
    });
  };

  const [sectionMapping, setSectionMapping] = useState([]);
  const saveTableData = async (data) => {
    const sectionData = data.sectionData.reduce((unique, o) => {
      if (!unique.some((obj) => obj.floor === o.floor)) {
        unique.push(o);
      }
      return unique;
    }, []);
    const sectiondataFilter = sectionData.filter((item) => item.floor);
    let sections = [];
    sectiondataFilter.forEach(function (item) {
      if (item.name && Number(item.name) == 1) sections.push(item);
      else if (item.name && Number(item.name) > 1) {
        for (let i = 1; i <= Number(item.name); i++) {
          const obj = {
            floor: item.floor,
            name: i + "",
          };
          sections.push(obj);
        }
      }
    });

    setLoading(true);
    const sectiondata = await PosService.createSections(
      sections,
      adminRestaurant
    );
    const tabledata = await PosService.createTables(
      data.tableData,
      adminRestaurant
    );

    if(sectionData)
       message.success("Updated sections successfully")

    setShowSection(true);
    getSectionAndTablesData();
  };

  const saveTableConfig = async (saveMapTable) => {
   const updatetable =  await PosService.mapTablesWithSection(
      adminRestaurant,
      saveMapTable
    );

    if(updatetable)
      message.success("Updated Table Mapping successfully")
  };

  return (
    <Layout className="u-page-layout">
      <Content className="page-padding">
        <PageHeader title={`Table Management`} style={{minHeight:80}} className="d-flex items-center page-header-business" />
        <div style={{ marginTop: "2rem" }} className="add-floor-table  content-container-business box-shadow-card">
          <TableDetails
            adminRestaurant={adminRestaurant}
            data={tableData}
            setData={saveTableData}
          />
        </div>

        {showSection && (
          <div style={{ marginTop: "2rem" }}>
            <TableConfiguration
              restaurant_id={adminRestaurant}
              tableData={tableData}
              saveTableConfig={saveTableConfig}
              // sectionMapping={sectionMapping}
              // setSectionMapping={setSectionMapping}
            />
          </div>
        )}
      </Content>
      {loading && <Spinner />}
      <R2Footer />
    </Layout>
  );
};

export default TableManagement;
